import { OriginBatteryDto, BatteryFilterType } from "app/ApiClient";
import { LoadingState } from "types";

export const DEFAULT_BATTERIES = ["Respondent_Serial", "Respondent_ID"];

export type BatteriesState = {
  loading: LoadingState;
  data: OriginBatteryDto[];
  searchText?: string;
  batteryFilterTypes: BatteryFilterType[];
};

export const initialBatteriesState: BatteriesState = {
  loading: LoadingState.idle,
  data: DEFAULT_BATTERIES.map<OriginBatteryDto>((name) => ({
    name,
    checked: true,
    isRespondable: true,
  })),
  batteryFilterTypes: [],
};
